<div mat-dialog-content [innerHTML]="message">
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()">{{ 'confirmation-dialog.no' | translate }}</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{ 'confirmation-dialog.yes' | translate }}</button>
</div>
